var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "p-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "auto" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "封面图：" } },
                    [
                      _c("upload", {
                        attrs: { "file-list": _vm.fileList },
                        on: { fileOk: _vm.fileOk },
                      }),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "abs",
                        attrs: { type: "hidden" },
                        model: {
                          value: _vm.form.img_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "img_url", $$v)
                          },
                          expression: "form.img_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { ref: "store_name", attrs: { label: "标题：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "投放范围：" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.is_all,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "is_all", $$v)
                          },
                          expression: "form.is_all",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.throw_agent_level && _vm.form.is_all == 0
                    ? _c("el-form-item", { attrs: { label: "范围：" } }, [
                        _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.throw_agent_level,
                                  callback: function ($$v) {
                                    _vm.throw_agent_level = $$v
                                  },
                                  expression: "throw_agent_level",
                                },
                              },
                              _vm._l(_vm.roles, function (item) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: item.level,
                                    attrs: { label: item.level },
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "介绍：" } },
                    [
                      _c("tinymce", {
                        attrs: { height: 300 },
                        model: {
                          value: _vm.form.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit("form")
                            },
                          },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }